module.exports = __webpack_public_path__ + "img/12px-list-style-checkmark.d594557c.svg";